import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HeaderUserComponent } from './header-user.component';

const routes: Routes = [{ path: '', component: HeaderUserComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HeaderUserRoutingModule { }
